import * as ScoreType from '../../../../../../constants/ScoreType';
import { Map } from 'immutable';
export function getGenericScores(scores, sportId) {
    var defaultScore = Map({ score1: 0, score2: 0 });
    var matchScores = (scores.filter(function (score) { return score.get('type') == ScoreType.Match; }).first() || defaultScore).toJS();
    var serve = (scores.filter(function (score) { return score.get('type') == ScoreType.Feed; }).first() || defaultScore).toJS();
    var powerplay;
    var homeTeamServe;
    var awayTeamServe;
    var team = serve ? serve.team : undefined;
    if (team !== undefined) {
        if (team === 1) {
            homeTeamServe = true;
            awayTeamServe = false;
        }
        else if (team === 2) {
            homeTeamServe = false;
            awayTeamServe = true;
        }
    }
    if (sportId === 30) {
        powerplay = (scores.filter(function (score) { return score.get("type") == ScoreType.PowerPlay; }).first() || defaultScore).toJS();
    }
    return {
        firstTeamTotal: matchScores.score1,
        secondTeamTotal: matchScores.score2,
        homeTeamServe: homeTeamServe,
        awayTeamServe: awayTeamServe,
        powerplay: powerplay
    };
}



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/statistics/mainScores/generic.js